import axios from 'axios';

const headers = {
  pragma: 'no-cache',
  'cache-control': 'no-cache',
};

export const post = ({ endpoint, params }) => axios.post(endpoint, params);

export const get = ({ endpoint, params }) => {
  console.log('getting endpoint', endpoint);
  return axios.get(endpoint, { headers, ...params });
};
